import Repository from '../../repositories/RepositoryFactory';
const ccmVaccineRepository = Repository.get('ccmVaccines');

export default {
	namespaced: true,
	state: {
		ccmVaccinesByPatientId: [],
		ccmVaccinesByCCMRecordId: [],
		ccmVaccine: null,
	},
	mutations: {
		STORE_CCM_VACCINE_BY_PATIENT_ID (state, payload) {
			state.ccmVaccinesByPatientId = payload;
		},
		STORE_CCM_VACCINE_BY_CCM_RECORD_ID (state, payload) {
			state.ccmVaccinesByCCMRecordId = payload;
		},
		STORE_CCM_VACCINE (state, payload) {
			state.ccmVaccine = payload;
		},
		UPDATE_CCM_VACCINE (state, payload) {
			state.ccmVaccine = {
				...state.ccmVaccine,
				...payload,
			};
		},
		UPDATE_CCM_VACCINE_IN_PATIENT_LIST (state, payload) {
			const index = state.ccmVaccinesByPatientId.findIndex((vaccine) => vaccine.id === payload.id);
			if (index !== -1) {
				state.ccmVaccinesByPatientId.splice(index, 1, {
					...state.ccmVaccinesByPatientId[index],
					...payload.body,
				});
			}
		},
		ADD_CCM_VACCINE_TO_PATIENT_LIST (state, payload) {
			state.ccmVaccinesByPatientId.unshift(payload);
		},
		REMOVE_CCM_VACCINE (state, id) {
			state.ccmVaccinesByPatientId = state.ccmVaccinesByPatientId.filter((vaccine) => vaccine.id !== id);
		},
	},
	actions: {
		async getCCMVaccinesByPatientId ({ commit }, patientId) {
			const response = await ccmVaccineRepository.getCCMVaccinesByPatientId(patientId);
			commit('STORE_CCM_VACCINE_BY_PATIENT_ID', response.data);
		},

		async getCCMVaccinesByCCMRecordId ({ commit }, ccmRecordId) {
			const response = await ccmVaccineRepository.getCCMVaccinesByCCMRecordId(ccmRecordId);
			commit('STORE_CCM_VACCINE_BY_CCM_RECORD_ID', response.data);
		},

		async getCCMVaccine ({ commit }, id) {
			const response = await ccmVaccineRepository.getCCMVaccine(id);
			commit('STORE_CCM_VACCINE', response.data);
		},

		async addCCMVaccine ({ commit }, body) {
			const response = await ccmVaccineRepository.addCCMVaccine(body);
			commit('ADD_CCM_VACCINE_TO_PATIENT_LIST', response.data);
		},

		async updateCCMVaccine ({ commit }, request) {
			commit('UPDATE_CCM_VACCINE', request.body);
			commit('UPDATE_CCM_VACCINE_IN_PATIENT_LIST', request);
			return await ccmVaccineRepository.updateCCMVaccine(request.id, request.body);
		},

		async deleteCCMVaccine ({ commit }, id) {
			commit('REMOVE_CCM_VACCINE', id);
			return await ccmVaccineRepository.deleteCCMVaccine(id);
		},
	},
};
